var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.7663 7.86676C13.2631 7.86676 12.7593 8.05845 12.3758 8.44294L8.44245 12.3763C7.67348 13.1452 7.67348 14.3903 8.44245 15.1573L22.7853 29.5001L8.44245 43.8429C7.67348 44.6119 7.67348 45.8569 8.44245 46.6239L12.3758 50.5573C13.1447 51.3262 14.3898 51.3262 15.1568 50.5573L29.4996 36.2144L43.8425 50.5573C44.6095 51.3262 45.8564 51.3262 46.6234 50.5573L50.5568 46.6239C51.3257 45.855 51.3257 44.6099 50.5568 43.8429L36.2139 29.5001L50.5568 15.1573C51.3257 14.3903 51.3257 13.1433 50.5568 12.3763L46.6234 8.44294C45.8545 7.67397 44.6095 7.67397 43.8425 8.44294L29.4996 22.7858L15.1568 8.44294C14.7723 8.05845 14.2695 7.86676 13.7663 7.86676V7.86676Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal_close.e062c092487d00e546e97b31bf45a086.svg";
export { ForwardRef as ReactComponent };